import { render, staticRenderFns } from "./member_transBg.vue?vue&type=template&id=123012fa&scoped=true&"
import script from "./member_transBg.vue?vue&type=script&lang=js&"
export * from "./member_transBg.vue?vue&type=script&lang=js&"
import style0 from "./member_transBg.vue?vue&type=style&index=0&id=123012fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123012fa",
  null
  
)

export default component.exports